import React from 'react';
import { ListLayout } from '../../global/tables/table-list-layout';
import { ZoomManagementActionArea } from './_zoom-management-actions-area';
import { Paging } from '../../global/_paging/paging-container';
import { PagingViewModel } from '../../global/_paging/paging-viewmodels/regular-paging.viewmodel';
import { ResourcesNavigation } from '../../_events/_manage-event/shared/navigation/navigation';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { connectZoomVM } from '../zoom.context';
import {
    IZoomUsersManagementRowProps,
    ZoomUsersManagementRowObserver,
} from './_zoom-users-management-row';
import './zoom-users-management.scss';
import { GROUPS_TEXT, LOADING } from '../../../constants/common-labels.constants';

interface IZoomUsersManagementProps {
    fetchError: string;
    visibleUsers: IZoomUsersManagementRowProps[];
    visibleUsersLength: number;
    pagingVM: PagingViewModel;
    intl?: IntlShape;
}

const ZoomUsersManagementPresentation = (props: IZoomUsersManagementProps) => {
    const { visibleUsers, fetchError, intl } = props;

    const thead = [
        '',
        intl.formatMessage({
            id: `oe.common.email`,
            defaultMessage: 'Email',
            description: 'Label text',
        }),
        intl.formatMessage({
            id: `oe.common.firstName`,
            defaultMessage: 'First Name',
            description: 'Label text',
        }),
        intl.formatMessage({
            id: `oe.common.lastName`,
            defaultMessage: 'Last Name',
            description: 'Label text',
        }),
        intl.formatMessage(GROUPS_TEXT),
    ];
    const showUsersList = !!(!fetchError && visibleUsers && visibleUsers.length);
    const showFetchingUsers = !visibleUsers && !fetchError;
    const showNoUsers = !fetchError && visibleUsers && !visibleUsers.length;

    return (
        <div>
            <section className='resources-tabs horizontal-row scheduled-meetings-list__horizontal-row'>
                <ResourcesNavigation />
            </section>
            <div className='zoom-users-management'>
                <h1>
                    <FormattedMessage
                        id='oe.users.addZoomUsers'
                        defaultMessage='Add Zoom Users'
                        description='Label text'
                    />
                </h1>
                <ListLayout thead={thead}>
                    {fetchError && <tr>
                        <td className='table-loading zoom-users-management__fetch-error' colSpan={4}>
                            <FormattedMessage
                                id='oe.records.apiErrorDuringFetching'
                                defaultMessage='API error during fetching records'
                                description='Placeholder text'
                            />: {fetchError} <br/>
                            <FormattedMessage
                                id='oe.records.errorMessageDescriptionPartOne'
                                defaultMessage='This may happens due to zoom API limitations, '
                                description='Placeholder text'
                            />
                            <FormattedMessage
                                id='oe.records.errorMessageDescriptionPartTwo'
                                defaultMessage='please wait a couple of seconds and refresh the page.'
                                description='Placeholder text'
                            />
                        </td>
                    </tr>}
                    {showUsersList && visibleUsers.map(x => <ZoomUsersManagementRowObserver rowProps={x} key={x.zoomUser.id} />)}
                    {showFetchingUsers && <tr><td className='table-loading' colSpan={5}>
                        <FormattedMessage
                            {...LOADING}
                            values={{
                                suffix: '...'
                            }}
                        />
                    </td></tr>}
                    {showNoUsers && <tr><td className='table-loading' colSpan={5}>
                        <FormattedMessage
                            id='oe.users.usersNotSelected'
                            defaultMessage='No users to be selected, check your zoom account.'
                            description='Label text'
                        />
                    </td></tr>}
                </ListLayout>
                <Paging pagingVM={props.pagingVM} />
                <ZoomManagementActionArea />
            </div>
        </div>
    );
};

const ZoomUsersManagement = injectIntl(connectZoomVM<IZoomUsersManagementProps>(ZoomUsersManagementPresentation, zoomVM => {
    const usersManagementVM = zoomVM.getUsersManagementVM();
    const visibleUsers = usersManagementVM.getVisibleUsers();
    return {
        checkUserSelection: usersManagementVM.isUserSelected,
        visibleUsers: visibleUsers,
        visibleUsersLength: visibleUsers && visibleUsers.length,
        fetchError: usersManagementVM.getFetchError(),
        pagingVM: usersManagementVM.getPagingVM()
    };
}));

export { ZoomUsersManagement };